import { LoadState } from "../../constants/enums";
import { IRoughEstimate } from "../leads/leads.types";

export interface IBookingState {
	bookingList: {
		list: IBooking[];
		loading: LoadState;
		totalRecords: number;
	};
	invoiceList: {
		list: IRoughEstimate[];
		loading: LoadState;
		totalRecords: number;
	};
}

export interface IBooking {
	booking_id: number;
	booking_unique_id?:number
	booking_uuid: string;
	capacity: number;
	create_ts: string;
	created_by_name: string;
	created_by_uuid: string;
	customer_email: string;
	customer_fact_uuid: string;
	customer_mobile_no: string;
	customer_name: string;
	from_date: string;
	insert_ts: string;
	leads_uuid: string;
	modified_by_name: string;
	modified_by_uuid: string;
	status: string;
	to_date: string;
	total_price: string;
	user_uuid: string;
	venue_name: string;
	venue_shift: string;
	venue_uuid: string;
	shift_time: string;
	company_outlet_uuid: string;
	company_outlet_name: string;
}

export const initialBookingState: IBookingState = {
	bookingList: {
		list: [],
		loading: LoadState.NotLoaded,
		totalRecords: 0,
	},
	invoiceList: {
		list: [],
		loading: LoadState.NotLoaded,
		totalRecords: 0,
	},
};
